import { render, staticRenderFns } from "./ocrCodeHandle.vue?vue&type=template&id=e352dca8&"
import script from "./ocrCodeHandle.vue?vue&type=script&lang=js&"
export * from "./ocrCodeHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e352dca8')) {
      api.createRecord('e352dca8', component.options)
    } else {
      api.reload('e352dca8', component.options)
    }
    module.hot.accept("./ocrCodeHandle.vue?vue&type=template&id=e352dca8&", function () {
      api.rerender('e352dca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/ocr/ocrCodeHandle.vue"
export default component.exports